export default __webpack_public_path__ + "static/media/CenterCircle.61060fc4.png";